module.exports = __webpack_public_path__ + "img/CIM.d041f66b.jpg";